import { Button } from '../../../components/ui/button';
import type { IntroScreen } from '../../../types/survey';
import { SurveyMarkdown } from './SurveyMarkdown';

// Phase 6B Phase D — the survey intro screen. "Get started" hands off to the
// runner; the page records startedAt + startedCount via the first answer / page
// view (telemetry already bumped on the GET).
export function IntroView({ intro, onStart }: { intro: IntroScreen; onStart: () => void }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h1 className="text-xl font-semibold text-slate-900">{intro.title || 'Survey'}</h1>
      {intro.estimatedDurationMinutes != null && intro.estimatedDurationMinutes > 0 && (
        <p className="mt-1 text-xs font-medium uppercase tracking-wide text-slate-400">
          Takes about {intro.estimatedDurationMinutes} minute{intro.estimatedDurationMinutes === 1 ? '' : 's'}
        </p>
      )}
      <SurveyMarkdown markdown={intro.bodyMarkdown} className="mt-4" />
      <div className="mt-6">
        <Button size="lg" onClick={onStart} className="w-full sm:w-auto">
          {intro.ctaLabel || 'Get started'}
        </Button>
      </div>
    </div>
  );
}
